import {
  Skeleton,
  Typography,
  Box,
  Card,
  Stack,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Computer, Devices, Wifi, WifiOff, GroupsSharp} from "@mui/icons-material";
import { useAuth } from "../../auth/useAuth";
import { can } from "../../auth/can";

import { APP_API_V1_BASE } from "../../config/api";
function DeviceCard() {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { permissions, activeOrg } = useAuth();
  const isPlatformOwner = can(permissions, "system.manage");

  useEffect(() => {
    const fetchDevices = async () => {
      try {
        setLoading(true);

        const token = localStorage.getItem("authToken");
        if (!token) return;

        // ⛔ permission guard
        if (!can(permissions, "stats.view")) {
          setTableData({});
          return;
        }

        const res = await axios.get(
          `${APP_API_V1_BASE}/devices/stats`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              ...(activeOrg?.id && { "X-Org-ID": activeOrg.id }),
            },
          },
        );

        // ✅ API already returns the exact structure you need
        setTableData(res.data || {});
      } catch (error) {
        console.error("Failed to fetch devices stats", error);
        setTableData({});
      } finally {
        setLoading(false);
      }
    };

    fetchDevices();
  }, [permissions, activeOrg]);

  // const totalDevices = useMemo(() => tableData.length, [tableData]);

  // const activeDevices = useMemo(() => {
  //   return tableData.filter((d) => d.status === "active").length;
  // }, [tableData]);

  // const deviceTypesCount = useMemo(() => {
  //   const types = new Set(
  //     tableData.map(
  //       (d) =>
  //         d.device_type?.name ||
  //         d.deviceType ||
  //         d.custom_type ||
  //         "Unknown"
  //     )
  //   );
  //   return types.size;
  // }, [tableData]);

  const cardData = [
    {
      title: "Total Devices",
      count: tableData?.total_devices,
      countColor: "#1E3A8A",
      bg: "#f4f5fa",
      icon: <Computer sx={{ color: "#1E3A8A" }} />,
      // color: "linear-gradient(135deg, #DBEAFE, #BFDBFE)",
      // text: "#1E3A8A"
    },
    {
      title: "Active Devices",
      count: tableData?.active_devices,
      countColor: "#16A34A",
      bg: "#DCFCE7",
      icon: <Wifi sx={{ color: "#3cae3c" }} />,
      // color: "linear-gradient(135deg, #DCFCE7, #BBF7D0)",
      // text: "#166534"
      // color: "#DCFCE7"
    },
    {
      title: isPlatformOwner ? "Device Types" : "Visible Types",
      count: tableData?.device_types,
      countColor: "#5B21B6",
      bg: "#f5f3f8",
      icon: <Devices sx={{ color: "#5B21B6" }} />,
      navigate: isPlatformOwner ? "/device_onboarding/devicetypes" : null,
    },
    {
      title: isPlatformOwner ? "Organizations" : "Inactive",
      count: isPlatformOwner
        ? tableData?.organizations
        : tableData?.inactive_devices,
      countColor: "#DC2626",
      bg: "#FEE2E2",
      icon: <GroupsSharp sx={{ color: "#DC2626" }} />,
    },
  ];

  if (loading) {
    return (
      <>
        {Array.from({ length: 4 }).map((_, index) => (
          <Box
            key={index}
            sx={{
              flex: "1 1 150px",
              width: { xs: "100%", md: "100%" },
            }}
          >
            <Card
              sx={{
                p: 3,
                position: "relative",
                overflow: "hidden",
                borderRadius: "24px",
                border: "1px solid rgba(148, 163, 184, 0.18)",
                background:
                  "linear-gradient(180deg, rgba(255,255,255,0.98), rgba(248,250,252,0.98))",
                boxShadow: "0 20px 50px rgba(15, 23, 42, 0.08)",
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  background:
                    "radial-gradient(circle at top right, rgba(59,130,246,0.12), transparent 32%)",
                  pointerEvents: "none",
                }}
              />

              <Stack spacing={2.5} sx={{ position: "relative", zIndex: 1 }}>
                <Stack direction="row" justifyContent="space-between">
                  <Skeleton
                    variant="rounded"
                    width={52}
                    height={52}
                    sx={{ borderRadius: "16px" }}
                  />
                  <Skeleton
                    variant="rounded"
                    width={64}
                    height={28}
                    sx={{ borderRadius: 999 }}
                  />
                </Stack>

                <Box>
                  <Skeleton variant="text" width="62%" height={22} />
                  <Skeleton variant="text" width="38%" height={18} />
                </Box>
              </Stack>
            </Card>
          </Box>
        ))}
      </>
    );
  }

  return (
    <>
      {cardData.map((card, index) => (
        <Box
          key={index}
          sx={{
            flex: "1 1 150px", // grow, shrink, base width
            width: { xs: "100%", md: "100%" }, // responsive max width
            // minWidth: "150px",
          }}
        >
          <Card
            sx={{
              p: 3,
              position: "relative",
              overflow: "hidden",
              borderRadius: "24px",
              border: "1px solid rgba(148, 163, 184, 0.18)",
              background:
                "linear-gradient(180deg, rgba(255,255,255,0.98), rgba(248,250,252,0.98))",
              boxShadow: "0 20px 50px rgba(15, 23, 42, 0.08)",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              cursor: card.navigate ? "pointer" : "default",
              transition: "transform 180ms ease, box-shadow 180ms ease",
              "&:hover": {
                transform: "translateY(-3px)",
                boxShadow: "0 28px 60px rgba(15, 23, 42, 0.12)",
              },
            }}
            onClick={() => card.navigate && navigate(card.navigate)}
          >
            <Box
              sx={{
                position: "absolute",
                inset: 0,
                background:
                  "radial-gradient(circle at top right, rgba(59,130,246,0.12), transparent 32%)",
                pointerEvents: "none",
              }}
            />
            {/* TOP */}
            <Box display="flex" justifyContent="space-between">
              <Box
                sx={{
                  width: 52,
                  height: 52,
                  borderRadius: "16px",
                  backgroundColor: card.bg,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "inset 0 1px 0 rgba(255,255,255,0.7)",
                }}
              >
                {card.icon}
              </Box>
              <Typography
                sx={{
                  color: card.countColor,
                  fontWeight: 600,
                  fontSize: "30px",
                  alignSelf: "flex-start",
                  px: 1.25,
                  py: 0.5,
                  borderRadius: 999,
                  backgroundColor: "rgba(255,255,255,0.85)",
                }}
              >
                 {card.count}
              </Typography>
            </Box>

            {/* BOTTOM */}
            <Box>
              <Typography
                sx={{
                  mt: 2,
                  color: "#6b7280",
                  fontSize: "13px",
                }}
              >
                {card.title}
              </Typography>

              <Typography
                sx={{
                  mt: 0.5,
                  position: "absolute",
                  top: 12,
                  right: 12,
                  fontSize: "12px",
                  fontWeight: 500,
                  whiteSpace: "nowrap",
                  color: card.detailColor,
                }}
              >
                {card.value}
              </Typography>
            </Box>
          </Card>
        </Box>
      ))}
    </>
  );
}

export default DeviceCard;
